export default {
      id: "delete-usage",
      viewBox: "0 0 266.29 209.96",
      url: __webpack_public_path__ + "img/icons.0fe16570.svg#delete-usage",
      toString: function () {
        return this.url;
      }
    }